export default __webpack_public_path__ + "static/media/telegram_grey.79690cd2.svg";